/**
 * 园区 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/park/'

const park = {
    /** ***********普通用户BEGIN***************/
    // 列表
    list(params) {
        return axios.get(api + 'list', { params: params })
    },
    // 商家列表
    agenttradesmanlist(params) {
        return axios.get(api + 'tradesmanlist', { params: params })
    },
    // 未审核商家列表
    pendtradesmanlist(params) {
        return axios.get(api + 'pendtradesman', { params: params })
    },
    // 审核商家
    reviewtrad(params) {
        return axios.post(api + 'reviewtrad', qs.stringify(params))
    },
    // 详情
    detail(params) {
        return axios.get(api + 'detail', { params: params })
    },
    // 添加园区
    create(params) {
        return axios.post(api + 'create', qs.stringify(params))
    },
    // 添加商家列表
    tradcreate(params) {
        return axios.post(api + 'tradcreate', qs.stringify(params))
    },
    // 商家详情
    traddetail(params) {
        return axios.get(api + 'traddetail', { params: params })
    },
    // 编辑商家
    tradedit(params) {
        return axios.post(api + 'tradedit', qs.stringify(params))
    },
    // 删除商户
    tradremove(params) {
        return axios.post(api + 'tradremove', qs.stringify(params))
    },
    // 可新增商家
    bintradlist(params) {
        return axios.post(api + 'tradbindtradlist', qs.stringify(params))
    },
    // 导入
    import(params) {
        return axios.post(api + 'import', qs.stringify(params))
    },

    // 代理商列表
    agentlist(params) {
        return axios.get(api + 'agentList', { params: params })
    },
    // 未审核代理商列表
    pendingagent(params) {
        return axios.get(api + 'pendingagent', { params: params })
    },
    // 审核代理商
    reviewagent(params) {
        return axios.post(api + 'reviewagent', qs.stringify(params))
    },
    // 未审核一级分销商列表
    pendingfirstagent(params) {
        return axios.get(api + 'pendingfirstagent', { params: params })
    },
    // 审核一级分销商
    reviewfirstagent(params) {
        return axios.post(api + 'reviewfirstagent', qs.stringify(params))
    },
    // 代理商列表
    noBindAgents(params) {
        return axios.get(api + 'noBindAgents', { params: params })
    },
    // 添加代理商
    agentCreate(params) {
        return axios.post(api + 'agentCreate', qs.stringify(params))
    }, // 编辑代理商
    agentEdit(params) {
        return axios.post(api + 'agentEdit', qs.stringify(params))
    },
    // 代理商详情
    agentDetail(params) {
        return axios.get(api + 'agentDetail', { params: params })
    },
    agentRemove(params) {
        return axios.post(api + 'agentRemove', qs.stringify(params))
    },
    //园区积分兑换
    scoredetail(params) {
        return axios.get(api + 'scoredetail', { params: params })
    },
    scoreedit(params) {
        return axios.post(api + 'scoreedit', qs.stringify(params))
    },
    //等级规则
    levellist(params) {
        return axios.get(api + 'levellist', { params: params })
    },
    // 添加等级规则
    levelcreate(params) {
        return axios.post(api + 'levelcreate', qs.stringify(params))
    },
    // 查看等级规则
    leveldetail(params) {
        return axios.get(api + 'leveldetail', { params: params })
    },
    // 修改等级规则
    leveledit(params) {
        return axios.post(api + 'leveledit', qs.stringify(params))
    },
    // 删除等级规则
    levelremove(params) {
        return axios.post(api + 'levelremove', qs.stringify(params))
    },
    //设置服务费
    serviceedit(params) {
        return axios.post(api + 'serviceedit', qs.stringify(params))
    },
}

// 导出接口
export default park
